export default __webpack_public_path__ + "static/custom-tooltips-550d0e13e8f97bd505364a0177e4f94b.png";